import { createFileRoute } from "@tanstack/react-router";
import { CrmTasksPanel } from "@/components/crm/CrmTasksPanel";

export const Route = createFileRoute("/crm/tasks")({
  head: () => ({
    meta: [
      { title: "CRM Tasks & Reminders | What Finland" },
      {
        name: "description",
        content:
          "Schedule upcoming calls, meetings and follow-ups with due dates and reminders across your What Finland CRM accounts.",
      },
      { property: "og:title", content: "CRM Tasks & Reminders | What Finland" },
      {
        property: "og:description",
        content: "Plan the next call or meeting and get reminded before it is due.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: TasksPage,
  errorComponent: ({ error }) => (
    <div className="p-6 text-sm text-rose-700">Failed to load tasks: {(error as Error).message}</div>
  ),
  notFoundComponent: () => <div className="p-6 text-sm">Not found.</div>,
});

function TasksPage() {
  return <CrmTasksPanel scope="mine" title="My Tasks" />;
}
